import type { FC } from 'react'
import { useRouter } from 'next/router'
import CartButton from '../../shopping-cart/buttons/CartButton'
import { useRecipient, useRecipientOpsDispatch } from '../RecipientProvider'
import { useRecipientSelect } from './RecipientSelectProvider'
import { classNames } from '@g4g/utils/src/react/class-names'
import gtm_add_shipping_info from '@/shop/src/utils/gtm/gtm_add_shipping_info'

const RecipientConfirm: FC = () => {
  const dispatch = useRecipientOpsDispatch()
  const { selectedRadioCosId, searchQuery } = useRecipientSelect()
  const { initiatedCheckout } = useRecipient()
  const router = useRouter()

  return (
    <div
      className={classNames(
        'container flex fixed right-0 bottom-0 left-0',
        'justify-between items-center px-4 h-16',
        'space-x-2 border-t lg:relative lg:border-0',
        'border-gray-600/20 bg-standardBg lg:bg-transparent z-50'
      )}
    >
      <CartButton
        className="w-full py-3 text-xl sm:text-base sm:py-2"
        data-cy="shop-recipient-select-btn"
        disabled={!selectedRadioCosId}
        onClick={() => {
          if (searchQuery.length > 1) {
            gtm_add_shipping_info('search-gift')
          }

          dispatch({ type: 'select-recipient', cosId: selectedRadioCosId })

          if (initiatedCheckout) {
            router.push('/checkout')
            return
          }

          router.push('/deals')
        }}
      >
        {initiatedCheckout ? 'Make Payment' : 'Select'}
      </CartButton>
    </div>
  )
}

export default RecipientConfirm
